<script lang='ts'>
    import { cn } from "@/lib/utils";
    import { format } from "date-fns";

    export let date: Date

    let className: string = undefined
    export { className as class }
    export let dateClass: string = undefined
    export let monthClass: string = undefined
</script>

<div class={cn("aspect-square w-28 flex flex-col flex-nowrap", className)}>
    <div class={cn("flex-grow border-solid border-[#e4e4e4] border-2 border-b-0 rounded-t-md flex items-center justify-center text-5xl", dateClass)}>
        <span class="my-auto font-bold">{format(date, 'd')}</span>
    </div>
    <div class={cn("h-8 flex-initial bg-[--color-xert-teal] rounded-b-md flex items-center justify-center text-white", monthClass)}>
        <span class="my-auto">{format(date, 'MMMM')}</span>
    </div>
</div>